/** Seats that can open Coverage. Sales reps stay on the Sales rail. */
export const COVERAGE_ROLES = [
  "marketing",
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "dev",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

const ROLE_SET = new Set<string>(COVERAGE_ROLES);

export function hasCoverageRole(roles: string[]): boolean {
  return roles.some((role) => ROLE_SET.has(role.trim().toLowerCase()));
}
